export const DO_LOGIN = "DO_LOGIN";
export const DO_LOGOUT = "DO_LOGOUT";
export const DO_LOCKED = "DO_LOCKED";
export const DO_UNLOCKED = "DO_UNLOCKED";
export const GET_PROFILE = "GET_PROFILE";
export const UPDATE_BALANCE = "UPDATE_BALANCE";
export const GET_BALANCE = "GET_BALANCE";